// extracted by mini-css-extract-plugin
module.exports = {"container":"Uj-z","list":"Vj-z"};